export enum Client {
  Incyte = 'incyte',
  Hexal = 'hexal',
  Novartis = 'novartis',
}
export enum IncyteInstance {
  Default = 'incyte',
  Onko = 'onko',
  Derma = 'derma',
}
export enum HexalInstance {
  Default = 'hexal',
}
export enum NovartisInstance {
  Default = 'novartis',
}
